export const setLocationCache = (location, cacheDuration) => {
  const locationStorage = {
    location,
    expireAt: Date.now() + cacheDuration * 24 * 60 * 60 * 1000
  };
  const locationCahe = JSON.parse(window.localStorage.getItem('location'));

  if (!locationCahe || locationCahe.expireAt <= Date.now()) {
    window.localStorage.setItem('location', JSON.stringify(locationStorage));
  }
};
export const getLocationFromCahce = () => {
  const locationCahe = JSON.parse(window.localStorage.getItem('location'));

  if (locationCahe && locationCahe.location && locationCahe.expireAt > Date.now()) {
    return locationCahe.location.locationZipCodes;
  }

  return null;
};